import { TreatmentRepository } from "@/domain/repository/treatment-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FinishTreatmentUsecase {
  constructor(private readonly treatmentRepo: TreatmentRepository) {}

  async execute(treatmentUuid: string): Promise<SATResult<void, SATError>> {
    return this.treatmentRepo.finishTreatment(treatmentUuid);
  }
}
